import React from 'react';

const UsageGuide: React.FC = () => {
  return (
    <div className="space-y-8">
      <div className="text-center mb-12">
        <h2 className="text-4xl font-bold mb-4 glow-text text-accent-cyan">
          使用指南
        </h2>
        <p className="text-text-secondary text-lg">
          快速集成到你的项目中
        </p>
      </div>

      <div className="glass-effect rounded-xl p-8">
        <h3 className="text-2xl font-semibold mb-4 text-text-primary">1. 安装依赖</h3>
        <div className="bg-background-darker rounded-lg p-4 border border-border-default">
          <pre className="text-text-secondary text-sm overflow-x-auto">
{`npm install tailwindcss autoprefixer postcss`}
          </pre>
        </div>
      </div>

      <div className="glass-effect rounded-xl p-8">
        <h3 className="text-2xl font-semibold mb-4 text-text-primary">2. 复制配置文件</h3>
        <p className="text-text-secondary mb-4">
          将以下文件复制到你的项目中：
        </p>
        <ul className="list-disc list-inside space-y-2 text-text-secondary mb-4">
          <li><code className="bg-background-darker px-2 py-1 rounded">src/config/colors.json</code></li>
          <li><code className="bg-background-darker px-2 py-1 rounded">src/config/colors.ts</code></li>
        </ul>
        <p className="text-text-secondary mb-4">
          或者直接使用 JSON 配置：
        </p>
        <div className="bg-background-darker rounded-lg p-4 border border-border-default">
          <pre className="text-text-secondary text-sm overflow-x-auto">
{`// tailwind.config.js
const colors = require('./src/config/colors.json');

module.exports = {
  theme: {
    extend: {
      colors: {
        primary: colors.primary,
        secondary: colors.secondary,
        accent: colors.accent,
        background: colors.background,
        surface: colors.surface,
        text: colors.text,
        border: colors.border,
        glow: colors.glow,
      },
    },
  },
};`}
          </pre>
        </div>
      </div>

      <div className="glass-effect rounded-xl p-8">
        <h3 className="text-2xl font-semibold mb-4 text-text-primary">3. 使用示例</h3>
        <div className="space-y-4">
          <div>
            <h4 className="text-lg font-semibold mb-2 text-text-primary">Tailwind CSS</h4>
            <div className="bg-background-darker rounded-lg p-4 border border-border-default">
              <pre className="text-text-secondary text-sm overflow-x-auto">
{`<div className="bg-background-dark text-text-primary">
  <button className="bg-accent-cyan/20 text-accent-cyan border border-accent-cyan/50">
    按钮
  </button>
</div>`}
              </pre>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-2 text-text-primary">CSS Variables</h4>
            <div className="bg-background-darker rounded-lg p-4 border border-border-default">
              <pre className="text-text-secondary text-sm overflow-x-auto">
{`/* 在你的 CSS 文件中定义变量 */
:root {
  --color-primary-500: #1890ff;
  --color-accent-cyan: #00ffff;
  --color-background-dark: #0a0e27;
  --color-text-primary: #ffffff;
}`}
              </pre>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-2 text-text-primary">JavaScript/TypeScript</h4>
            <div className="bg-background-darker rounded-lg p-4 border border-border-default">
              <pre className="text-text-secondary text-sm overflow-x-auto">
{`import { colors } from './config/colors';

const buttonStyle = {
  backgroundColor: colors.accent.cyan,
  color: colors.text.primary,
};`}
              </pre>
            </div>
          </div>
        </div>
      </div>

      <div className="glass-effect rounded-xl p-8">
        <h3 className="text-2xl font-semibold mb-4 text-text-primary">4. 常用组合</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="bg-background-darker rounded-lg p-4 border border-border-default">
            <h4 className="text-lg font-semibold mb-2 text-text-primary">玻璃态卡片</h4>
            <pre className="text-text-secondary text-xs overflow-x-auto">
{`className="glass-effect rounded-xl p-6 border border-border-default"`}
            </pre>
          </div>
          <div className="bg-background-darker rounded-lg p-4 border border-border-default">
            <h4 className="text-lg font-semibold mb-2 text-text-primary">光晕按钮</h4>
            <pre className="text-text-secondary text-xs overflow-x-auto">
{`className="bg-accent-cyan/20 text-accent-cyan border border-accent-cyan/50 hover:shadow-glow"`}
            </pre>
          </div>
          <div className="bg-background-darker rounded-lg p-4 border border-border-default">
            <h4 className="text-lg font-semibold mb-2 text-text-primary">发光文本</h4>
            <pre className="text-text-secondary text-xs overflow-x-auto">
{`className="text-accent-cyan glow-text"`}
            </pre>
          </div>
          <div className="bg-background-darker rounded-lg p-4 border border-border-default">
            <h4 className="text-lg font-semibold mb-2 text-text-primary">渐变背景</h4>
            <pre className="text-text-secondary text-xs overflow-x-auto">
{`className="bg-gradient-to-br from-accent-cyan/20 to-accent-blue/20"`}
            </pre>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UsageGuide;
